class UnexpectedStockOutflowStatusRepository {
    async getAll() {
        throw new Error('Method not implemented');
    }
}

module.exports = UnexpectedStockOutflowStatusRepository; 